/**
 * Attempts to keep a WebSocket alive by sending a given message at a given regular interval.
 */
export class KeepaliveWebSocket extends WebSocket {
	public constructor(url: string, keepaliveMessage: string, keepaliveMilliseconds: number) {
		super(url);

		let keepaliveHandle: number | undefined;

		this.addEventListener('open', (): void => {
			keepaliveHandle = window.setInterval(
				() => this.send(keepaliveMessage),
				keepaliveMilliseconds,
			);
		});

		this.addEventListener('close', (): void => {
			if (keepaliveHandle !== undefined) {
				window.clearInterval(keepaliveHandle);
			}
		});
	}
}
